import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  SimpleList,
  Show,
  SimpleShowLayout
} from "react-admin";
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';

export const EnfardadoresFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
      <TextInput label="Usuario/dni" source="searchdni" autoFocus />
    </Filter>
  )
}

const EnfardadorNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Enfardador</span>}
      medium={
        <span>Editar Enfardador: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

const EnfardadorNameShow = ({ record }) => {
  return <span>Mostrando: {record ? `"${record.nombre}"` : ""}</span>;
};

export const EnfardadorShow = props => (
  <Show title={<EnfardadorNameShow />} {...props}>
    <SimpleShowLayout>
      <TextField label="Nombre y Apellido" source="nombre" />
      <TextField label="Usuario o dni" source="dni" />
    </SimpleShowLayout>
  </Show>
);

export const EnfardadorEdit = props => (
  <Edit title={<EnfardadorNameEdit />} {...props}>
    <SimpleForm>
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="Usuario o dni" source="dni" />
      <TextInput label="Contraseña" source="validacion" type="password" />
    </SimpleForm>
  </Edit>
);

export const EnfardadorCreate = props => (
  <Create {...props} title="Registrar Enfardador">
    <SimpleForm redirect="/enfardadores">
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="Usuario o dni" source="dni" />
      <TextInput label="Contraseña" type="password" source="validacion" />
    </SimpleForm>
  </Create>
);

export const EditableEnfardadorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<EnfardadoresFilter />}
    exporter={false}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
          tertiaryText={record => "Usuario/dni: " + record.dni}
        />
      }
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField source="dni" label="Usuario/dni"/>
          <CreateEnfardadorButton history={props.history} />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const EnfardadorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<EnfardadoresFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          tertiaryText={record => "Usuario/dni: " + record.dni}
          linkType="show"
        />
      }
      medium={
        <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" label="Usuario/dni" />
        </Datagrid>
      }
    />
  </List>
);

class CreateEnfardadorButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Link to="/enfardadores">
        <IconButton
          style={{fontWeight: 'regular', fontSize: '0.8125rem'}}
          aria-label="Crear Enfardador" color="primary"
        >
        </IconButton>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/enfardador.js